// extracted by mini-css-extract-plugin
export default {"windTile":"wind-tile_windTile__a-Gei","largeText":"wind-tile_largeText__cGICe","windContainer":"wind-tile_windContainer__sneTc"};